import { FilterCheckOutlineIcon } from './FilterCheckOutlineIcon';

/**
 * author: Michael Irigoyen
 * id FFDED2FF-7CB6-4D02-BEE6-A82C16625386
 * name filter-check-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filter-check-outline.svg
 * tags
 */
export const FunnelCheckOutlineIcon = FilterCheckOutlineIcon;
export default FunnelCheckOutlineIcon